import React from 'react';
import { Link  } from "react-router-dom";


const Home = () => {
    return ( 
        <div className="home">
            <div className="wrap"><Link className="link" to="/start" >Get started</Link></div>
        </div>
     );
}
 
export default Home;